import React from 'react';
import { MdChevronRight } from 'react-icons/md';
import FileTypeIcon, { getFileTypeClass } from './FileTypeIcon';
import { getDocumentMetaLabel, ParsedDocumentLink } from '../utils/documentLinks';

interface DocumentLinkCardsProps {
  heading?: string | null;
  documents: ParsedDocumentLink[];
}

const DocumentLinkCards: React.FC<DocumentLinkCardsProps> = ({ heading, documents }) => {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div className="document-link-cards">
      {heading && (
        <span className="document-link-cards-heading">{heading}</span>
      )}
      <div className="document-link-cards-list">
        {documents.map((doc) => {
          const isAlreadyEncoded = /%[0-9A-Fa-f]{2}/.test(doc.url);
          const href = isAlreadyEncoded ? doc.url : encodeURI(doc.url);

          return (
            <a
              key={doc.url}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="document-link-card"
              title={doc.url}
            >
              <div className={`document-link-card-icon ${getFileTypeClass(doc.url)}`}>
                <FileTypeIcon url={doc.url} />
              </div>
              <div className="document-link-card-body">
                <div className="document-link-card-title">{doc.title}</div>
                <div className="document-link-card-meta">{getDocumentMetaLabel(doc.url)}</div>
              </div>
              <MdChevronRight className="document-link-card-chevron" aria-hidden="true" />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default DocumentLinkCards;
